module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1043.34b10a64.png";